const pagePathMap = {
  home: '/',
  products: '/products',
  colours: '/colours',
  customize: '/customize',
  strength: '/strength',
  quality: '/quality',
  care: '/care',
  cases: '/cases',
  knowledge: '/knowledge',
  contact: '/contact'
}

export function getWebBaseUrl () {
  return (process.env.VUE_APP_WEB_BASE_URL || 'http://localhost:8080').replace(/\/$/, '')
}

export function toPreviewUrl (path) {
  const normalizedPath = path && path.startsWith('/') ? path : `/${path || ''}`
  return `${getWebBaseUrl()}/#${normalizedPath}`
}

export function productPreviewUrl (row) {
  return toPreviewUrl(`/products-page/${row.slug}`)
}

export function categoryPreviewUrl (row) {
  return toPreviewUrl(`/products-list/${row.slug}`)
}

export function casePreviewUrl (row) {
  return toPreviewUrl(`/cases/${row.slug}`)
}

export function articlePreviewUrl (row) {
  return toPreviewUrl(`/news/${row.slug}`)
}

export function pageSectionPreviewUrl (row) {
  return toPreviewUrl(pagePathMap[row.pageKey] || '/')
}

export function openPreviewUrl (url) {
  window.open(url, '_blank', 'noopener,noreferrer')
}
